webpackJsonp([43369700788870],{

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact-banner.0677d16e.jpg";

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact-BAM.b01c33f1.png";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    '], ['\n    ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin-bottom: ', ';\n      font-size: 28px;\n      line-height: 36px;\n    '], ['\n      margin-bottom: ', ';\n      font-size: 28px;\n      line-height: 36px;\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      padding-top: ', ';\n    '], ['\n      padding-top: ', ';\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    margin-top: 100px;\n  '], ['\n    margin-top: 100px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    justify-content: space-between;\n  '], ['\n    display: flex;\n    justify-content: space-between;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n      margin: 0;\n    '], ['\n      margin: 0;\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    width: calc(50% - 30px);\n\n    img {\n      max-width: 100%;\n    }\n\n    ', '\n  '], ['\n    width: calc(50% - 30px);\n\n    img {\n      max-width: 100%;\n    }\n\n    ', '\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    text-align: initial;\n  '], ['\n    text-align: initial;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n      padding: 0 0 0 30px;\n    '], ['\n      padding: 0 0 0 30px;\n    ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0;\n  '], ['\n    padding: 100px 0;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n      margin-top: ', ';\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    '], ['\n      margin-top: ', ';\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    background-position: top right;\n    min-height: 700px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  '], ['\n    background-position: top right;\n    min-height: 700px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _reactScroll = __webpack_require__(76);
	
	var _contactBAM = __webpack_require__(1471);
	
	var _contactBAM2 = _interopRequireDefault(_contactBAM);
	
	var _contactBanner = __webpack_require__(1458);
	
	var _contactBanner2 = _interopRequireDefault(_contactBanner);
	
	var _shared = __webpack_require__(7);
	
	var _routes = __webpack_require__(24);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import location from 'images/contact-location.jpg';
	
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Wrapper'
	})(['background-color:', ';h2{margin-bottom:', ';font-size:36px;line-height:42px;font-weight:700;color:', ';', ';}h3{margin-bottom:', ';font-size:24px;line-height:36px;font-weight:500;color:', ';', ';a{color:', ';font-weight:600;}}h4{padding-top:', ';font-size:24px;line-height:36px;font-weight:500;color:', ';', ';}'], colors.blueIce, sp.xl, colors.navy, _styles.media.tablet(_templateObject), sp.m, colors.royal, _styles.media.tablet(_templateObject2, sp.l), colors.blue, sp.m, colors.cobalt, _styles.media.tablet(_templateObject3, sp.l));
	
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Content'
	})(['margin-top:60px;', ';p{font-size:24px;line-height:36px;font-weight:500;color:', ';}img{display:block;margin:0 auto;max-width:100%;}'], _styles.media.tablet(_templateObject4), colors.royal);
	
	/* const Location = styled.div`
	  margin-bottom: 100px;
	
	  a {
	    text-decoration: none;
	    color: ${colors.blue};
	  }
	
	  ${media.tablet`
	    margin-bottom: 0;
	  `};
	`; */
	
	var ColumnWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__ColumnWrapper'
	})(['', ';'], _styles.media.tablet(_templateObject5));
	
	var Column = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Column'
	})(['img{max-width:60%;}&:first-child{margin-bottom:', ';', ';}', ';'], sp.xxl, _styles.media.tablet(_templateObject6), _styles.media.tablet(_templateObject7, function (props) {
	  return props.nudge && '\n      padding-top: 22px;\n    ';
	}));
	
	var Details = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Details'
	})(['margin-bottom:50px;']);
	
	var DetailHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__DetailHeader'
	})(['max-width:500px;text-align:center;margin:0 auto;']);
	
	var DetailWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__DetailWrapper'
	})(['display:flex;justify-content:space-between;flex-direction:column;', ';'], _styles.media.tablet(_templateObject8));
	
	var DetailWrapperItem = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__DetailWrapperItem'
	})(['text-align:center;', ';'], _styles.media.tablet(_templateObject9));
	
	var Bam = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Bam'
	})(['h3{font-size:2.2em;font-weight:600;color:', ';}'], colors.navy);
	
	var List = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__List'
	})(['ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';}ol,ul{padding:0;font-size:20px;', ';}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}'], sp.xxl, _styles.media.tablet(_templateObject10), sp.s, colors.blue, sp.s, colors.blue);
	
	var Banner = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'contact-us__Banner'
	})(['position:relative;background-image:url(\'', '\');background-size:cover;background-position:top center;background-repeat:no-repeat;padding:60px 0 100px;', ';h1{color:', ';max-width:600px;font-size:40px;line-height:48px;letter-spacing:-0.8px;margin-top:', ';margin-bottom:', ';font-weight:700;', ';}&::before{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(43,88,153,0.7);content:\'\';}', ';'], function (props) {
	  return props.src;
	}, _styles.media.tablet(_templateObject11), colors.white, sp.xxl, sp.xxl, _styles.media.tablet(_templateObject12, sp.l), _styles.media.tablet(_templateObject13));
	
	function ContactUs() {
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: 'Contact Us',
	    link: '/contact-us'
	  }];
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: 'Contact Us | On Demand Marketing Services | MarketTap',
	      description: 'Contact us to find out how we can help your e-commerce business sell more online with our our unique pay-as-you-go model. Get in touch today.'
	    }),
	    _react2.default.createElement(
	      Banner,
	      { src: _contactBanner2.default },
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(_shared.Breadcrumbs, { breadcrumbs: breadcrumbs, left: true, light: true }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Need Help?',
	          _react2.default.createElement('br', null),
	          'Have a question?'
	        ),
	        _react2.default.createElement(
	          _shared.Button,
	          { yellow: true, scroll: true, onClick: function onClick() {
	              return _reactScroll.animateScroll.scrollTo(500);
	            } },
	          'Get in touch'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        Details,
	        null,
	        _react2.default.createElement(
	          _shared.Container,
	          null,
	          _react2.default.createElement(
	            DetailHeader,
	            null,
	            _react2.default.createElement(
	              'h2',
	              { id: 'scrollto' },
	              'Our team is available by phone, email, or live chat.'
	            )
	          ),
	          _react2.default.createElement(
	            DetailWrapper,
	            null,
	            _react2.default.createElement(
	              DetailWrapperItem,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Toll Free:'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                '+1 (866) 302-0414'
	              )
	            ),
	            _react2.default.createElement(
	              DetailWrapperItem,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'General:'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:info@markettap.com' },
	                  'info@markettap.com'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              DetailWrapperItem,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Job Inquiries:'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:work@markettap.com' },
	                  'work@markettap.com'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Bam,
	        null,
	        _react2.default.createElement(
	          _shared.Container,
	          null,
	          _react2.default.createElement(
	            ColumnWrapper,
	            null,
	            _react2.default.createElement(
	              Column,
	              null,
	              _react2.default.createElement('img', { src: _contactBAM2.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              Column,
	              { nudge: true },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Get answers to your marketing questions - it\u2019s free.'
	              ),
	              _react2.default.createElement(
	                List,
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Book a time slot that is most convenient for you.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Type in your questions so we can make the best use of your time.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'No credit card required for Free Consultation.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _shared.Button,
	                { yellow: true, to: _routes2.default.bookMarketer.index },
	                'Book a call'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = ContactUs;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-10ac88acc449c34c89ed.js